var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div id=\"address-helper\">\n  <input type=\"hidden\" class=\"selectionCache\">\n  <div class=\"street\">\n    <div ng-bind-html=\"t('addressHelperHint')\" class=\"streetInputHint\"></div>\n    <input type=\"text\" placeholder=\"{{ t('addressHelperStreetName') }}\" class=\"streetInput\">\n    <div class=\"streetContainer\"></div>\n  </div>\n  <div class=\"streetNumber\">\n    <input type=\"text\" placeholder=\"{{ t('addressHelperStreetNo') }}\" class=\"streetNumberInput\">\n    <div class=\"streetNumberContainer\"></div>\n  </div>\n  <div class=\"zip\">\n    <input type=\"text\" placeholder=\"{{ t('addressHelperZip') }}\" tabindex=\"-1\" readonly class=\"zipLabel\">\n  </div>\n  <div class=\"city\">\n    <input type=\"text\" placeholder=\"{{ t('addressHelperCity') }}\" tabindex=\"-1\" readonly class=\"cityLabel\">\n  </div>\n  <div class=\"error\">{{ t('addressHelperNoCoords') }}</div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/addressHelper.jade
 ** module id = 64
 ** module chunks = 1
 **/